import React from 'react'
import PortfolioAnalysis from './portfolio_analysis/PortfolioAnalysis'

const MyPortfolio2 = () => {
  return (
    <PortfolioAnalysis />
  )
}

export default MyPortfolio2;